module.exports = __webpack_public_path__ + "img/total.357336b0.png";